export enum TypeDocument {
	JobDocument = 0
}

export enum JobModelType {
	Job = 0,
	Crm = 1
}
